import { render, staticRenderFns } from "./EditSalesHours.vue?vue&type=template&id=ecb72d14&scoped=true"
import script from "./EditSalesHours.vue?vue&type=script&lang=js"
export * from "./EditSalesHours.vue?vue&type=script&lang=js"
import style0 from "./EditSalesHours.vue?vue&type=style&index=0&id=ecb72d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb72d14",
  null
  
)

export default component.exports